import { render } from "./not-found.vue?vue&type=template&id=5cb9bf30"
const script = {}
script.render = render

export default script